<button
  class="primary-back-button"
  type="button"
  [style.padding-bottom.rem]="paddingBottomRem"
  (click)="backClicked.emit()">
  <img [src]="'assets/icons/primary/ChevronLeft.svg'" alt="go back" i18n-alt />
  {{ label }}
</button>
